export default __webpack_public_path__ + "static/media/sn-help-machine.882ab84c.png";